import { render, staticRenderFns } from "./item-info.vue?vue&type=template&id=06984b59&scoped=true"
import script from "./item-info.vue?vue&type=script&lang=js"
export * from "./item-info.vue?vue&type=script&lang=js"
import style0 from "./item-info.vue?vue&type=style&index=0&id=06984b59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06984b59",
  null
  
)

export default component.exports